import { render, staticRenderFns } from "./OnboardingOnfido.vue?vue&type=template&id=05c405a8&"
import script from "./OnboardingOnfido.vue?vue&type=script&lang=js&"
export * from "./OnboardingOnfido.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingOnfido.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports